import React from "react";
import { useSelector } from "react-redux";
import Participant from "../Participant";

const ListMe = () => {
  const me = useSelector((state) => state.me);
  const settings = useSelector((state) => state.settings);
  me.displayName = settings.displayName;

  return <Participant participant={me} disabled={true} />;
};

export default ListMe;
